import Main from './main';
import Edit from './edit';
import SingleAcademyCategory from './single';

const routes = [
  {
    path: '/*',
    Component: Main,
    props: {
      exact: true,
    },
  },
  {
    path: '/new',
    Component: Edit,
    props: {
      isNew: true,
    },
  },
  {
    path: '/:id/edit',
    Component: Edit,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id',
    Component: SingleAcademyCategory,
    props: {
      exact: true,
    },
  },
];

export default routes;
